import { peekBillingPendingPlan } from "@/features/billing/billingPendingPlan";

export const BILLING_CHECKOUT_PARAM = "checkout";
export const BILLING_PORTAL_PARAM = "portal";
export const BILLING_INTENT_PARAM = "intent";
export const BILLING_ACCT_PARAM = "acct";
export const BILLING_UPGRADE_PRO_INTENT = "upgrade_pro";
export const BILLING_CANCEL_INTENT = "cancel";

function hasReturnAccountId(searchParams: URLSearchParams): boolean {
  return Boolean(searchParams.get(BILLING_ACCT_PARAM)?.startsWith("acct_"));
}

export function hasBillingConfirmTicket(
  searchParams: URLSearchParams,
  pendingPlan: string | null,
): boolean {
  if (searchParams.get(BILLING_CHECKOUT_PARAM) === "success") {
    return Boolean(pendingPlan) || hasReturnAccountId(searchParams);
  }
  if (!pendingPlan) {
    return false;
  }
  return (
    searchParams.get(BILLING_PORTAL_PARAM) === "success" &&
    searchParams.get(BILLING_INTENT_PARAM) === BILLING_UPGRADE_PRO_INTENT
  );
}

export function isBillingCancelReturn(searchParams: URLSearchParams): boolean {
  return (
    searchParams.get(BILLING_PORTAL_PARAM) === "success" &&
    searchParams.get(BILLING_INTENT_PARAM) === BILLING_CANCEL_INTENT
  );
}

/** Checkout or Portal came back to /billing — restore login, do not send to Welcome. */
export function isStripeBillingReturnSearch(searchParams: URLSearchParams): boolean {
  const checkout = searchParams.get(BILLING_CHECKOUT_PARAM);
  if (checkout === "success" || checkout === "cancel") {
    return true;
  }
  if (searchParams.get(BILLING_PORTAL_PARAM) === "success") {
    return true;
  }
  return hasReturnAccountId(searchParams);
}

export function isOrphanBillingReturnUrl(searchParams: URLSearchParams): boolean {
  const pending = peekBillingPendingPlan();
  if (
    searchParams.get(BILLING_CHECKOUT_PARAM) === "success" &&
    !pending &&
    !hasReturnAccountId(searchParams)
  ) {
    return true;
  }
  if (isBillingCancelReturn(searchParams)) {
    return false;
  }
  if (searchParams.get(BILLING_PORTAL_PARAM) === "success") {
    if (!pending || searchParams.get(BILLING_INTENT_PARAM) !== BILLING_UPGRADE_PRO_INTENT) {
      return true;
    }
  }
  return false;
}

export function billingReturnParamsToClear(): string[] {
  return [BILLING_CHECKOUT_PARAM, BILLING_PORTAL_PARAM, BILLING_INTENT_PARAM];
}
